import { Injectable } from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {UserPrivilegeService} from '../../../services/common/user-privilege/user-privilege.service';
import {RoleTypeEnum} from '../../../services/enums/role-type.enum';

@Injectable({
  providedIn: 'root'
})
export class AdministrationGuard implements CanActivate {
  private readonly defaultUnauthorizedSettingsUrl = 'settings/networkServices/syslog';

  constructor(private router: Router,
              private userPrivilege: UserPrivilegeService) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.userPrivilege.isAuthorized()) {
      return true;
    }

    if (this.router.url.endsWith('/settings') || this.router.url.endsWith('/settings/administration')) {
      this.router.navigate([this.defaultUnauthorizedSettingsUrl]);
    }
    return false;
  }
}
